var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        _vm.elementType,
        { tag: "component", staticClass: "items-list row" },
        _vm._l(_vm.items, function (item, index) {
          return _c("li", { key: "item" + index, staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "items-list-item",
                class: _vm.highlight ? "highlight" : "",
              },
              [
                _c("span", {
                  staticClass: "item-icon",
                  class: item.icon,
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-container",
                    class: _vm.noBorderBottom ? "no-border-bottom" : "",
                  },
                  [
                    _c("div", { staticClass: "item-text" }, [
                      _c("p", {
                        staticClass: "mb-0",
                        domProps: { innerHTML: _vm._s(item.label) },
                      }),
                    ]),
                  ]
                ),
              ]
            ),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }